import { USER_GUIDE_LINK } from "../config";

type CollaboLinkPanelProps = {
  collaboName: string | null;
};

// The name comes from GET /v3/collabo/portal/pending (never the URL) and is display-only;
// it is rendered as text and never used to decide who is signing in. Showing it lets the
// user spot linking the wrong person.
export const CollaboLinkPanel = ({ collaboName }: CollaboLinkPanelProps) => (
  <section
    aria-label="コラボポータル連携"
    className="flex flex-col gap-2 break-words rounded-lg border border-primary p-4 text-center"
  >
    <p className="font-bold text-base text-primary">コラボポータル連携</p>
    {collaboName && <p className="font-bold text-lg">{collaboName}様</p>}
    <p className="text-muted-foreground text-sm">
      このアカウントと連携を行います。
      <br />
      お名前に間違いがないかご確認ください。
    </p>
  </section>
);

export const CollaboSignupGuide = () => (
  <p className="text-center text-muted-foreground text-sm">
    まだ medimo アカウントをお持ちでない方は
    <br />
    <a
      href={USER_GUIDE_LINK}
      target="_blank"
      rel="noreferrer"
      className="text-primary underline"
    >
      こちらから登録方法をご確認ください
    </a>
  </p>
);
